<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    (blur)="onTouched()"
    [required]="required"
    [disabled]="disabled"
    [errorStateMatcher]="errorStateMatcher"
  >
    @for (qualification of values; track $index) {
      <mat-option [value]="qualification">
        {{ qualification }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
